type BlogListQueryParams = {
  category?: string
  page?: number | string
  limit?: number | string
}

export const getBlogListQueryParams = ({
  page = 1,
  limit = 20,
  ...rest
}: BlogListQueryParams = {}) => ({
  ...rest,
  status: "PUBLISHED",
  sortBy: "createdAt",
  sortOrder: "DESC",
  page: String(page),
  limit: String(limit),
})
